__turbopack_context__.v({
  "root": "_1IVKNW_root",
});
